import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '@service/core/theme.service';

@Component({
  selector: 'app-page-error',
  template: `
    <div
      class="flex justify-center items-center overflow-hidden max-h-screen h-full"
    >
      <div class="text-center relative max-h-full overflow-y-auto mt-[15%]">
        <div class="flex justify-center items-center">
          <svg
            class="Cog pb-10"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            [ngStyle]="{ fill: _themeService.colorCode() }"
          >
            <path
              d="M29.18 19.07c-1.678-2.908-.668-6.634 2.256-8.328L28.29 5.295c-.897.527-1.942.83-3.057.83-3.36 0-6.085-2.743-6.085-6.126h-6.29c.01 1.043-.25 2.102-.81 3.07-1.68 2.907-5.41 3.896-8.34 2.21L.566 10.727c.905.515 1.69 1.268 2.246 2.234 1.677 2.904.673 6.624-2.24 8.32l3.145 5.447c.895-.522 1.935-.82 3.044-.82 3.35 0 6.066 2.725 6.083 6.092h6.29c-.004-1.035.258-2.08.81-3.04 1.676-2.902 5.4-3.893 8.325-2.218l3.145-5.447c-.9-.515-1.678-1.266-2.232-2.226zM16 22.48c-3.578 0-6.48-2.902-6.48-6.48S12.423 9.52 16 9.52c3.578 0 6.48 2.902 6.48 6.48s-2.902 6.48-6.48 6.48z"
            />
          </svg>
        </div>

        <h1
          class="MainTitle"
          [ngStyle]="{ color: _themeService.isDark() ? 'white' : '#000' }"
        >
          An error has occurred
        </h1>
        <p
          class="Main Description mb-4"
          [ngStyle]="{ color: _themeService.isDark() ? 'white' : '#000' }"
        >
          Server is currently under high load - please hit 'reload' on your
          browser in a minute to try again
        </p>
        <button
          type="button"
          class="flex-none rounded-md bg-primary px-4 py-2.5 text-xs font-semibold text-primary-foreground"
          (click)="reload()"
        >
          Reload
        </button>
      </div>
    </div>
  `,
  styleUrl: './page-error.component.scss',
  imports: [NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageErrorComponent {
  protected _router = inject(Router);
  protected _themeService = inject(ThemeService);

  protected reload(): void {
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate([this._router.url]).then(() => {});
    });
  }
}
